import { useQuery } from "@tanstack/react-query";

import { ExpediteDeliveryResponse } from "@web-app/types";
import http from "@web-app/utils/http";

export const useExpedite = (id: string, entity: string) => {
  const get = async () => {
    return http
      .post<ExpediteDeliveryResponse>(
        `/integrations/expedite/get?id=${id}&entity=${entity}`,
      )
      .then((response) => response.data)
      .catch(() => {
        return null;
      });
  };

  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryFn: get,
    queryKey: ["expedite-get-delivery", id],
  });

  return {
    data,
    isLoading,
    isRefetching,
    refetch,
  };
};
